import React from 'react'

/* Style */
import './Switching.css'
import '../../css/Switching.css';

// Modules
import { Avatar, Button } from 'antd';

const Switching = (props) => {
    /* Define column one of round of 16 confrontations */
    let roundOf16Competitors01 = props.roundOf16Competitors.map((competitor, index) => {

        /* Separate columns from the switch */
        if (competitor.colunaUm) {

            /* Change the color if competitor is fit */
            let localColor = ''
            if (!competitor.apto)
                localColor = 'red'

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Change margin top/bottom to separate confrontations */
            let localMarginBottom = '5px'
            if (index % 2 !== 0)
                localMarginBottom = '15px'

            /* Define additional to pointer the loser competitor *
            let localAddKeyLose = 1
            if(index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Show cancel option */
            /*
            let localDisplayBlockNone = 'block'
            if(competitor.nome === '')
                localDisplayBlockNone = 'none'
            */

            return (
                <div
                    key={index}
                    className="switchingSubBlock01"
                    style={{ backgroundColor: localBgColor, color: localColor, marginBottom: localMarginBottom }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%' }}
                    //onClick={() => this.chooseACompetitor(index, index, index + localAddKeyLose, 'roundOf16', competitor)}
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    {/*<div
                        className='switchingClearButtonRoundOf16'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => this.clearCompetitor(index, 'roundOf16')}
                    >X</div>
                    */}
                </div>
            )
        } else { return null }
    })

    /* Draw lines between round of 16 and quarter finals  */
    let linesBetweenRoundOf16AndQuarterFinals01 = props.arrayForLines01.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '17.5625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '39.125px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '31.5625px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenRoundOf16AndQuarterFinals02 = props.arrayForLines01.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '36.625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '52.625px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenRoundOf16AndQuarterFinals03 = props.arrayForLines01.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '17.5625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '39.125px', borderBottomStyle: 'solid', borderLeftStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '31.5625px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    /* Define column one of quarter finals confrontations */
    let quarterFinalsCompetitors01 = props.quarterFinalsCompetitors.map((competitor, index) => {
        /* Separate columns from the switch */
        if (competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor *
            let localAddKeyLose = 1
            if(index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '20.0625px'
            if (index !== 0)
                localMarginTop = '54.625px'

            /* Show cancel option */
            /*
            let localDisplayBlockNone = 'block'
            if(competitor.nome === '')
                localDisplayBlockNone = 'none'
            */

            return (
                <div
                    key={index}
                    className="switchingSubBlock02"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%' }}
                    //onClick={() => this.chooseACompetitor(index, index, index + localAddKeyLose, 'quarterFinals', competitor)}
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    {/*<div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer', top: '-43px' }}
                        onClick={() => this.clearCompetitor(index, 'quarterFinals')}
                    >X</div>
                    */}
                </div>
            )
        } else { return null }
    })

    /* Draw lines between quarter finals and semi finals  */
    let linesBetweenQuarterAndSemiFinals01 = props.arrayForLines02.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '36.625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '89.75px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '53.1875px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenQuarterAndSemiFinals02 = props.arrayForLines02.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '82.75px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '96.5px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenQuarterAndSemiFinals03 = props.arrayForLines02.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '36.625px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '89.75px', borderBottomStyle: 'solid', borderLeftStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '53.1875px', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    /* Define column one of semi finals confrontations */
    let semiFinalsCompetitors01 = props.semiFinalsCompetitors.map((competitor, index) => {
        /* Separate columns from the switch */
        if (competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor *
            let localAddKeyLose = 1
            if(index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '66.1875px'
            if (index !== 0)
                localMarginTop = '143.9375px'

            /* Show cancel option */
            /*
            let localDisplayBlockNone = 'block'
            if(competitor.nome === '')
                localDisplayBlockNone = 'none'
            */

            return (
                <div
                    key={index}
                    className="switchingSubBlock03"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%' }}
                    //onClick={() => this.chooseACompetitor(index, index, index + localAddKeyLose, 'semiFinals', competitor)}
                    > &nbsp; {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    {/*<div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer', top: '-43px' }}
                        onClick={() => this.clearCompetitor(index, 'semiFinals')}
                    >X</div>
                    */}
                </div>
            )
        } else { return null }
    })

    /* Draw lines between semi finals and final  */
    let linesBetweenSemiAndFinal01 = props.arrayForLines03.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '82.75px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '179.5px', borderBottomStyle: 'solid', borderRightStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenSemiAndFinal02 = props.arrayForLines03.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '172.5px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    let linesBetweenSemiAndFinal03 = props.arrayForLines03.map(count => {
        return (
            <div key={count} style={{ float: 'left', width: '100%' }}>
                <div style={{ height: '82.75px', borderBottomStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
                <div style={{ height: '179.5px', borderBottomStyle: 'solid', borderLeftStyle: 'solid', borderWidth: '1px', borderColor: 'gray', float: 'left', width: '100%' }}>&nbsp;</div>
            </div>
        )
    })

    /* Define column one of final confrontations */
    let finalCompetitors01 = props.finalCompetitors.map((competitor, index) => {
        /* Separate columns from the switch */
        if (competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor *
            let localAddKeyLose = 1
            if(index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Show cancel option */
            /*
            let localDisplayBlockNone = 'block'
            if(competitor.nome === '')
                localDisplayBlockNone = 'none'
            */

            return (
                <div
                    key={index}
                    className="switchingSubBlock04"
                    style={{ backgroundColor: localBgColor, marginTop: '155.4375px', color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%' }}
                    //onClick={() => this.chooseACompetitor(index, index, index + localAddKeyLose, 'final', competitor)}
                    > &nbsp; {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    {/*<div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer', top: '-43px' }}
                        onClick={() => this.clearCompetitor(index, 'final')}
                    >X</div>
                    */}
                </div>
            )
        } else { return null }
    })

    /* Define column two of round of 16 confrontations */
    let roundOf16Competitors02 = props.roundOf16Competitors.map((competitor, index) => {
        /* Separate columns from the switch */
        if (!competitor.colunaUm) {

            /* Change the color if competitor is fit */
            let localColor = ''
            if (!competitor.apto)
                localColor = 'red'

            /* Change margin top/bottom to separate confrontations */
            let localBgColor = 'white'
            if (index % 2 === 0) {
                localBgColor = 'gainsboro'
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginBottom = '5px'
            if (index % 2 !== 0)
                localMarginBottom = '15px'

            /* Define additional to pointer the loser competitor *
            let localAddKeyLose = 1
            if(index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Show cancel option */
            /*
            let localDisplayBlockNone = 'block'
            if(competitor.nome === '')
                localDisplayBlockNone = 'none'
            */

            return (
                <div
                    key={index}
                    className="switchingSubBlock01"
                    style={{ backgroundColor: localBgColor, color: localColor, marginBottom: localMarginBottom }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%' }}
                    //onClick={() => this.chooseACompetitor(index, index, index + localAddKeyLose, 'roundOf16', competitor)}
                    > &nbsp;{competitor.nome}&nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    {/*<div
                        className='switchingClearButtonRoundOf16'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer' }}
                        onClick={() => this.clearCompetitor(index, 'roundOf16')}
                    >X</div>
                    */}
                </div>
            )
        } else { return null }
    })

    /* Define column two of quarter finals confrontations */
    let quarterFinalsCompetitors02 = props.quarterFinalsCompetitors.map((competitor, index) => {
        /* Separate columns from the switch */
        if (!competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor *
            let localAddKeyLose = 1
            if(index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '20.0625px'
            if (index !== 2)
                localMarginTop = '54.625px'

            /* Show cancel option */
            /*
            let localDisplayBlockNone = 'block'
            if(competitor.nome === '')
                localDisplayBlockNone = 'none'
            */

            return (
                <div
                    key={index}
                    className="switchingSubBlock02"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%' }}
                    //onClick={() => this.chooseACompetitor(index, index, index + localAddKeyLose, 'quarterFinals', competitor)}
                    > &nbsp; {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    {/*<div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer', top: '-43px' }}
                        onClick={() => this.clearCompetitor(index, 'quarterFinals')}
                    >X</div>
                    */}
                </div>
            )
        } else { return null }
    })

    /* Define column two of semi finals confrontations */
    let semiFinalsCompetitors02 = props.semiFinalsCompetitors.map((competitor, index) => {
        /* Separate columns from the switch */
        if (!competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor *
            let localAddKeyLose = 1
            if(index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1

            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Change margin top/bottom to separate confrontations */
            let localMarginTop = '66.1875px'
            if (index !== 2)
                localMarginTop = '143.9375px'

            /* Show cancel option */
            /*
            let localDisplayBlockNone = 'block'
            if(competitor.nome === '')
                localDisplayBlockNone = 'none'
            */

            return (
                <div
                    key={index}
                    className="switchingSubBlock03"
                    style={{ backgroundColor: localBgColor, marginTop: localMarginTop, color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%' }}
                    //onClick={() => this.chooseACompetitor(index, index, index + localAddKeyLose, 'semiFinals', competitor)}
                    > &nbsp; {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    {/*<div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer', top: '-43px' }}
                        onClick={() => this.clearCompetitor(index, 'semiFinals')}
                    >X</div>
                    */}
                </div>
            )
        } else { return null }
    })

    /* Define column two of final confrontations */
    let finalCompetitors02 = props.finalCompetitors.map((competitor, index) => {
        /* Separate columns from the switch */
        if (!competitor.colunaUm) {

            /* Change the background color to easily visualization */
            let localBgColor = 'white'
            if (index % 2 === 0)
                localBgColor = 'gainsboro'

            /* Define additional to pointer the loser competitor *
            let localAddKeyLose = 1
            if(index % 2 === 0)
                localAddKeyLose = 1
            else
                localAddKeyLose = -1
            
            /* Change color to define who won */
            let localColor = ''
            if (competitor.hasWon) {
                //localBgColor = ''
                localColor = ''
            }

            /* Show cancel option */
            /*
            let localDisplayBlockNone = 'block'
            if(competitor.nome === '')
                localDisplayBlockNone = 'none'
            */

            return (
                <div
                    key={index}
                    className="switchingSubBlock04"
                    style={{ backgroundColor: localBgColor, marginTop: '155.4375px', color: localColor }}
                >
                    <div
                        className='sharedTextIntoDiv'
                        style={{ float: 'left', width: '80%' }}
                    //onClick={() => this.chooseACompetitor(index, index, index + localAddKeyLose, 'final', competitor)}
                    > &nbsp; {competitor.nome} &nbsp;</div>
                    <div
                        className='sharedTextIntoDiv'
                        style={{ display: 'block', width: '80%', color: 'dimgray', fontStyle: 'italic', fontSize: 'xx-small' }}
                    >&nbsp;{competitor.equipe}&nbsp;</div>
                    {/*<div
                        className='switchingClearButton'
                        style={{ display: localDisplayBlockNone, cursor: 'pointer', top: '-43px' }}
                        onClick={() => this.clearCompetitor(index, 'final')}
                    >X</div>
                    */}
                </div>
            )
        } else { return null }
    })

    return (
        <div>
            <div id='printAreaOfSharedSwitching'>
                <div style={{ color: 'gray', fontSize: 'small', marginBottom: '30px', marginTop: '30px', display: 'block', fontWeight: 'lighter', textAlign: 'center' }}>
                    <Avatar
                        style={{ backgroundColor: props.studentFaixa }}
                        size='small'
                        shape='square'
                    ></Avatar>&nbsp; &nbsp;
                    <span style={{ fontSize: 'x-large' }}>{props.switchingId > 100 ? 'Chave absoluto ' + (props.switchingId - 100) : 'Chave ' + props.switchingId}</span><br /><br />

                    Sexo: {props.studentSexo} |&nbsp;
                    Peso: {props.studentPeso} |&nbsp;
                    Idade: {props.studentIdade}
                </div>

                <div className='SharedSwitchingContent'>
                    <div className='SharedSwitchingSubContent'>
                        <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                            {roundOf16Competitors01}
                        </div>

                        <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals01} </div>
                        <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals02} </div>

                        <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                            {quarterFinalsCompetitors01}
                        </div>

                        <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals01} </div>
                        <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals02} </div>

                        <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                            {semiFinalsCompetitors01}
                        </div>

                        <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal01} </div>
                        <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal02} </div>

                        <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                            {finalCompetitors01}
                        </div>

                        <div className='switchingBetweenBlock'>&nbsp;
                            <div className='switchingRanking' style={{ borderStyle: 'none' }}> {props.champion !== undefined ? this.state.champion.substring(0, 20) : ''} </div>
                        </div>

                        <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                            {finalCompetitors02}
                        </div>

                        <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal02} </div>
                        <div className='switchingBetweenBlock'> {linesBetweenSemiAndFinal03} </div>

                        <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                            {semiFinalsCompetitors02}
                        </div>

                        <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals02} </div>
                        <div className='switchingBetweenBlock'> {linesBetweenQuarterAndSemiFinals03} </div>

                        <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                            {quarterFinalsCompetitors02}
                        </div>

                        <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals02} </div>
                        <div className='switchingBetweenBlock'> {linesBetweenRoundOf16AndQuarterFinals03} </div>

                        <div className="switchingBlock" style={{ display: 'inlineBlock' }}>
                            {roundOf16Competitors02}
                        </div>

                    </div>
                </div>

                <iframe title="ifmcontentstoprint_shared_switching" id="ifmcontentstoprint_shared_switching" style={{ height: '0px', width: '0px', position: 'absolute' }}></iframe>

            </div>
            <Button type='primary' onClick={() => props.renderPdf()}>Imprimir</Button>
            {/* <div className='SharedSwitchingObs'>Deslize para o lado para ver os demais confrontos</div> */}
        </div>
    )
}

export default Switching